export default {
  modul: 'Ir a modulo de tareas',
  gps: 'GPS',
  version: 'Versión',
  notification: ' Sin Notificaciones',
  administration: 'Administración',
  support: 'Soporte',
  contactSupport: 'Contactar Soporte',
  news: 'Noticias',
  profile: 'Perfil',
  logout: 'Salir',
  adm: 'Administración',
  user: {
    profile: 'Usuario',
    api_keys: 'API keys'
  },
  home: 'Inicio',
  dashboard: 'Dashboard',
  'notices': {
    index: 'Noticias'
  },
  'admin-notices-center': {
    index: 'Noticias'
  },
  'admin-forms': {
    index: 'Formularios',
    edit: 'Editar Formulario',
    build: 'Construir Formulario',
    preview: 'Previsualización',
    new: 'Crear Formulario'
  },
  'admin-organizations': {
    index: 'Organizaciones',
    'index-table': 'Organizaciones',
    new: 'Crear organización',
    edit: 'Editar organización'
  },
  'admin-organization-subaccounts': {
    index: 'Subcuentas',
    new: 'Crear subcuenta',
    edit: 'Editar subcuenta'
  },
  'admin-franchises': {
    index: 'Unidades de Negocio',
    edit: 'Editar unidad de negocio',
    new: 'Crear unidad de negocio'
  },
  'admin-locations': {
    index: 'Ubicaciones',
    edit: 'Editar Ubicación',
    new: 'Crear Ubicación',
    groups: 'Administrar grupos'
  },
  'admin-roles': {
    index: 'Roles',
    edit: 'Editar Rol',
    new: 'Alta de Rol',
    tree: 'Organigrama de Roles',
    tree_configuration: 'Configuración de Organigrama'
  },
  'admin-users': {
    index: 'Usuarios',
    edit: 'Editar Usuario',
    new: 'Alta de Usuario'
  },
  'manager-users': {
    index: 'Usuarios',
    edit: 'Editar Usuario'
  },
  'super-admin-users': {
    index: 'Usuarios',
    'index-table': 'Usuarios',
    edit: 'Editar Usuario',
    new: 'Alta de Usuario'
  },
  'super-admin-licenses': {
    index: 'Licencias',
    franchises: 'Licencias por unidad de negocio',
    users: 'Licencias de usuarios',
    report: 'Reporte de licencias'
  },
  'super-admin-analytics': {
    index: 'Analytics',
    'dashboard-new': 'Nuevo tablero',
    'dashboard-edit': 'Editar tablero',
    organization: 'Organización'
  },
  'admin-catalogs': {
    index: 'Catálogos',
    edit: 'Editar Catálogo',
    new: 'Alta de Catálogo'
  },
  'admin-notifications-center': {
    index: 'Centro de notificaciones'
  },
  'admin-sprints': {
    index: 'Sprints'
  },
  'admin-calendar': {
    index: 'Sprints',
    new: 'Crear Sprint',
    edit: 'Edición de Sprint'
  },
  'admin-campaigns': {
    index: 'Campañas',
    new: 'Crear Campaña',
    edit: 'Edición de Campaña'
  },
  mailing: {
    index: 'Mailing'
  },
  'super-admin-organizations': {
    index: 'Organizaciones',
    'index-table': 'Organizaciones',
    new: 'Crear organización',
    edit: 'Editar organización'
  },
  'super-admin-forms': {
    index: 'Formularios',
    edit: 'Editar Formulario',
    build: 'Construir Formulario',
    'build-cloned': 'Construir Formulario Clonado',
    preview: 'Previsualización',
    new: 'Crear Formulario'
  },
  'super-admin-franchises': {
    index: 'Unidades de Negocio',
    edit: 'Editar unidad de negocio',
    new: 'Crear unidad de negocio'
  },
  'super-admin-locations': {
    index: 'Ubicaciones',
    edit: 'Editar Ubicación',
    new: 'Crear Ubicación',
    groups: 'Administrar grupos'
  },
  'super-admin-roles': {
    index: 'Roles',
    edit: 'Editar Rol',
    new: 'Alta de Rol'
  },
  'super-admin-catalogs': {
    index: 'Catálogos',
    edit: 'Editar Catálogo',
    new: 'Alta de Catálogo'
  },
  'super-admin-sprints': {
    index: 'Sprints'
  },
  'super-admin-campaigns': {
    index: 'Campañas',
    new: 'Crear Campaña',
    edit: 'Edición de Campaña'
  },
  'super-admin-mailing': {
    index: 'Mailing'
  },
  'dashboard-settings': 'Configuración',
  'admin-settings': 'Configuración',
  aria: {
    index: 'Documentación Aria',
    new: 'Crear documento o reporte',
    edit: 'Editar documento o reporte'
  },
  'occurrences': 'Formularios',
  'occurrence_fill': 'Llenar Formulario',
  action_plans: {
    index: 'Tareas',
    new: 'Nuevo Plan de Acción',
    fill: 'Llenar Plan de Acción',
    edit: 'Editar Plan de Acción',
    show: 'Tareas'
  },
  missions: {
    index: 'Misiones'
  },
  photosGallery: {
    index: 'Galería',
    dashboard: 'Galería de Fotos',
    SprintGallery: 'Galería de Sprint',
    FormGallery: 'Galería de Formulario'
  },
  caducities: {
    index: 'Caducidades'
  },
  exhibitions: {
    // El header de la app (junto a la campana) toma el titulo de la ruta:
    // debe quedarse en "Exhibiciones" en todo el modulo. El header de pantalla
    // (junto a la flecha de regresar) es el que muestra el contexto por vista.
    index: 'Exhibiciones',
    new: 'Exhibiciones',
    show: 'Exhibiciones',
    details: 'Exhibiciones',
    settings: 'Exhibiciones'
  },
  routines: {
    index: 'Rutinas'
  },
  quick_check: {
    index: 'Revision rapida'
  },
  service_desk: {
    index: 'Mesa de servicio'
  },
  control_tower: {
    index: 'Torre de Control'
  },
  dashboard2: {
    index: 'Analítica'
  },
  'analytics-dashboards': {
    index: 'Analytics'
  },
  reports: {
    index: 'Reportes',
    report: 'Reporte'
  },
  calendar: 'Agenda',
  resources: {
    index: 'Recursos',
    create: 'Crear Recurso',
    show: 'Recurso'
  },
  // Rutas de administración — módulo de encuestas / Voice Value (routes/admins.js)
  survey: {
    view: 'Previsualización de encuesta',
    edit: 'Configuración de encuesta',
    link: 'Enlace de encuesta'
  },
  'admin-surveys': {
    brand: 'Voice Value',
    index: 'Encuestas'
  },
  'user-profile': 'Perfil'
}
